import SimpleFormPage from "../common/SimpleFormPage";
import MansionFields from "./MansionFields";

export default function NewMansion() {
  return (
    <SimpleFormPage title="Nuova mansione">
      <MansionFields />
    </SimpleFormPage>
  );
}
